import { User as OidcClientUser, UserManager } from "oidc-client-ts";
import { AppStore } from "../store";
import { Service } from "./service";
import { AppRouter } from "../appConfig";
import { cleanOidcUrl } from "../utils/cleanOidcUrl";

export class SignInService implements Service<void, void> {
  constructor(
    private readonly store: AppStore,
    private readonly window: Window,
    private readonly oidcManager: UserManager,
    private readonly router: AppRouter,
  ) {}

  async call() {
    try {
      const oidcUser: OidcClientUser | null = await this.oidcManager.signinRedirectCallback();
      if (oidcUser) {
        // Clean up URL after successful signin, otherwise the page will infinitely
        // reload on page refresh
        const cleanedUpUrl = cleanOidcUrl(this.window.location.href);
        this.window.history.replaceState({}, this.window.document.title, cleanedUpUrl);
        this.router.state.location.search = cleanedUpUrl.search;
        this.router.state.location.hash = cleanedUpUrl.hash;

        try {
          this.store.setState({
            authState: {
              type: "signed-in",
              user: {
                id: oidcUser.profile.sub,
                name: oidcUser.profile.name ?? "",
                email: oidcUser.profile.email,
                mobileNumber: (oidcUser.profile as { mobile_number?: string }).mobile_number,
              },
            },
          });

          console.debug("Logged in successfully:", oidcUser.profile);
        } catch (error) {
          console.debug("Error during parsing of server authentication data:", error);
          this.store.setState({ authState: { type: "error", error: error as Error } });
        }
      }
    } catch (_error) {
      try {
        // Get rid of pre-existing invalid OpenID Connect query params, otherwise they will
        // take precedence on the new ones returned by the OpenID Connect server
        // and we will infinitely loop between this app and the OpenID Connect server
        // Keep ?evc= in the redirect_uri so Keycloak preserves it on callback
        const redirectUri = cleanOidcUrl(this.window.location.href);

        await this.oidcManager.signinRedirect({
          redirect_uri: redirectUri.toString(),
        });
      } catch (signinError) {
        console.debug("Error during authentication:", signinError);
        this.store.setState({ authState: { type: "error", error: signinError as Error } });
      }
    }
  }
}
